import {faFilter as fasFilter} from '@fortawesome/free-solid-svg-icons';
import {faUndo} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {setFilter, useAppSelector} from '../../../redux';
import {Button} from '../../_shared/button/button';
import Dialog from '../../_shared/dialog/dialog';
import MainFilterForm from '../main-filter-form/main-filter-form';
import styles from './marketplace-modal-filter.module.scss';

const MarketplaceModalFilter = () => {
    const dispatch = useDispatch();
    const [showDialog, setShowDialog] = useState(false);
    const filter = useAppSelector(state => state.productSlice.detailedInstances.filter);

    const resetFilter = () => {
        if (filter) {
            const currentFilters = [
                ...filter.filter(item =>
                    (
                        item.param === 'status' ||
                        item.param === 'sort' ||
                        item.param === 'ownerId')
                )
            ]
            dispatch(setFilter(currentFilters));
        }
    }


    return (
        <div className={styles['marketplace-filter-modal']}>
            <Button
                onClick={resetFilter}
                className={styles['filter-mobile-buttons']}>
                <FontAwesomeIcon icon={faUndo}/></Button>
            <Button className={styles['filter-mobile-buttons']}
                    onClick={() => setShowDialog(true)}><FontAwesomeIcon icon={fasFilter}/></Button>
            {showDialog && <Dialog onClose={() => setShowDialog(false)}>
                <MainFilterForm openInDialog={true}
                                onCloseModal={() => setShowDialog(false)}/>
            </Dialog>}
        </div>
    )
}

export default MarketplaceModalFilter;
